/**
 * Small help button mounted in the admin header. Clicking it re-starts
 * the onboarding tour — that's the entire contract. The hook owns the
 * auto-start + persistence logic.
 */

import React from "react";
import { Question } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useAdminOnboarding } from "./useAdminOnboarding";

export default function OnboardingHelpButton({ className = "" }) {
  const { user } = useAuth();
  const { start, reset } = useAdminOnboarding(user);

  const handleClick = () => {
    // Wipe the "seen" flag so replay feels like a fresh start — and keeps
    // the auto-start/manual-start code paths identical.
    reset();
    start();
  };

  return (
    <Button
      data-testid="onboarding-help-btn"
      variant="ghost"
      size="sm"
      onClick={handleClick}
      title="Revoir le guide"
      aria-label="Revoir le guide de prise en main"
      className={
        "text-zinc-400 hover:text-amber-400 hover:bg-zinc-800 px-2 " + className
      }
    >
      <Question size={18} weight="bold" />
    </Button>
  );
}
